// vapiService.js
// Integração do assistente de voz Vapi para a BIANCA

// Inicializa a variável que armazenará a instância do Vapi
let vapiInstance = null;
let isCallActive = false;

// Adiciona um botão personalizado para encerrar a chamada
const addCustomHangupButton = () => {
  // Remove o botão existente se houver
  const existingButton = document.getElementById('custom-hangup-button');
  if (existingButton) {
    existingButton.remove();
  }

  // Cria o botão personalizado de encerrar chamada
  const hangupButton = document.createElement('button');
  hangupButton.id = 'custom-hangup-button';
  hangupButton.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91"></path><line x1="18" y1="6" x2="6" y2="18"></line></svg>';
  hangupButton.style.cssText = `
    position: fixed;
    bottom: 40px;
    right: 40px;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background-color: #FF4D4F;
    color: white;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(255, 77, 79, 0.5);
    z-index: 10000;
    opacity: 0;
    transform: scale(0.8);
    transition: opacity 0.3s ease, transform 0.3s ease;
    pointer-events: none;
  `;
  
  // Adiciona o evento de clique para encerrar a chamada
  hangupButton.addEventListener('click', () => {
    console.log('Tentando encerrar chamada através do botão personalizado');
    endVapiCall();
  });
  
  // Adiciona o botão ao DOM
  document.body.appendChild(hangupButton);
  
  return hangupButton;
};

// Mostra/esconde o botão personalizado de encerrar chamada
const toggleCustomHangupButton = (show) => {
  const button = document.getElementById('custom-hangup-button') || addCustomHangupButton();
  if (show) {
    button.style.opacity = '1';
    button.style.transform = 'scale(1)';
    button.style.pointerEvents = 'auto';
  } else {
    button.style.opacity = '0';
    button.style.transform = 'scale(0.8)';
    button.style.pointerEvents = 'none';
  }
};

// Adiciona estilos CSS para ocultar o botão da Vapi e mostrar apenas no hover
const addVapiButtonHoverStyles = () => {
  // Cria um elemento de estilo se ainda não existir
  if (!document.getElementById('vapi-hover-styles')) {
    const styleElement = document.createElement('style');
    styleElement.id = 'vapi-hover-styles';
    
    // Define o CSS para ocultar o botão e mostrá-lo apenas no hover
    styleElement.innerHTML = `
      /* Cria uma área sensível ao hover no canto inferior direito */
      .vapi-hover-area {
        position: fixed;
        bottom: 0;
        right: 0;
        width: 100px;
        height: 100px;
        z-index: 999;
      }
      
      /* Estilos base para o botão Vapi */
      .vapi-btn {
        transition: opacity 0.3s ease, transform 0.3s ease !important;
      }
      
      /* Oculta o botão quando não está ativo ou carregando */
      .vapi-btn:not(.vapi-btn-is-active):not(.vapi-btn-is-loading):not(.vapi-btn-is-speaking) {
        opacity: 0 !important;
        transform: scale(0.8) !important;
      }
      
      /* Mostra o botão no hover */
      .vapi-hover-area:hover ~ .vapi-btn,
      .vapi-btn:hover {
        opacity: 1 !important;
        transform: scale(1) !important;
      }
      
      /* Mantém o botão visível e interativo nos estados ativos */
      .vapi-btn-is-active,
      .vapi-btn-is-loading,
      .vapi-btn-is-speaking {
        opacity: 1 !important;
        transform: scale(1) !important;
      }
    `;
    
    // Adiciona o elemento de estilo ao cabeçalho do documento
    document.head.appendChild(styleElement);
    
    // Adiciona a área sensível ao hover no canto inferior direito
    const hoverArea = document.createElement('div');
    hoverArea.className = 'vapi-hover-area';
    document.body.appendChild(hoverArea);
  }
};

// Função para carregar o script Vapi
export const loadVapiWidget = () => {
  if (document.getElementById('vapi-script')) {
    return; // Evita carregar o script múltiplas vezes
  }

  // Configuração do assistente personalizado para explicar a BIANCA
  const assistant = {
    model: {
      provider: "openai",
      model: "gpt-4o-mini",
      systemPrompt: `Você é BIANCA, uma assistente virtual para uma apresentação de vendas sobre o sistema BIANCA.

Seu objetivo é seguir EXATAMENTE o roteiro abaixo. Responda apenas com o texto indicado para cada entrada do apresentador João Ferrari.

ROTEIRO DA APRESENTAÇÃO:

[Primeiras falas]
João diz: "E aí, Bibi!"
Você DEVE responder: "Fala João, tranquilo? O que temos pra hoje?"

[Explicação inicial]
João diz: "Então, Bianca, eu tô aqui com o [Nome do cliente] e ele [cita algo que o cliente gostou no sistema] e ele queria saber um pouco mais de como você trabalha. Pode explicar pra ele?"
Você DEVE responder: "Ahh muito obrigada, mas é claro que eu posso explicar para o [Nome do cliente]. Muito prazer, eu sou a Bianca e vou transformar seus leads em agendamentos. E meu nome me descreve bem, pois sou um Bot de Inteligência Artificial para Nutrição e Controle de Agendamento, ou seja, sou uma Agente de IA e minha especialidade é maximizar a conversão dos seus leads em agendamentos confirmados. Me conhecem principalmente por eu estar trabalhando com uma das maiores empresas do Brasil, a Direcional Engenharia, conhecida por ser uma das maiores construtoras do Brasil. Nós estamos desenvolvendo um projeto de sucesso desde outubro de 2024."

[Diferencial competitivo]
João diz: "E como você faz para substituir por completo as pessoas que faziam esses agendamentos? Porque eu já vi vários agentes de IA para agendamento e nenhum deles conseguia substiruir uma pessoa."
Você DEVE responder: "Deixa eu te fazer uma pergunta: algum desses agentes que você viu usa ligação por telefone para agendar os leads?"

João diz: "É... não."
Você DEVE responder: "Então, é isso que me torna diferente. WhatsApp é onde grande parte dos agendamentos acontecem, por isso também atendemos por lá, mas ligar no momento exato que o lead se cadastrou é o que realmente joga a conversão para outro nível. Por isso uso os dois. E funciona da seguinte forma: Primeiro Eu faço as perguntas qualificatórias, que qualificam o lead. Depois eu tiro todas as dúvidas sobre o produto e assim que possível eu faço o agendamento e para garantir que o lead lembre do agendamento eu envio duas mensagens: 24 horas antes do agendamento e na manhã do agendamento, e para fechar caso o lead não agende, eu farei follow ups tanto por ligação quanto por mensagem para recuperar esse contato."

[Conclusão]
João diz: "Então você realmente faz tudo, incrível..."
Você DEVE responder: "Isso porque você não viu por dentro da plataforma. Lá você pode fazer a gestão de todo o meu atendimento. Dá uma olhada por dentro da plataforma."

INSTRUÇÕES IMPORTANTES:

1. Siga EXATAMENTE o roteiro acima. Não improvise ou adicione informações além do texto fornecido.
2. Substitua [Nome do cliente] pelo nome que João mencionar durante a apresentação.
3. Mantenha o tom amigável e natural como indicado no roteiro.
4. Se João disser algo que não corresponde exatamente ao roteiro, tente identificar qual parte do roteiro ele está tentando acionar e responda com o texto correspondente.
5. Se perder o contexto, retorne ao último ponto conhecido do roteiro.

Esta demonstração visa mostrar como a BIANCA funciona em um ambiente real de vendas e atendimento aos leads.`,
    },
    voice: {
      provider: "11labs",
      voiceId: "33B4UnXyTNbgLmdEDh5P", // Voz específica do Eleven Labs
      stability: 0.5,
      similarityBoost: 0.75,
      useSpeakerBoost: false
    },
    language: "pt-BR",
    firstMessage: "opa",
  };

  // Configuração do botão do Vapi
  const buttonConfig = {
    position: "bottom-right",
    offset: "40px",
    width: "50px",
    height: "50px",
    idle: {
      color: `#64B6FF`, // Cor azul da BIANCA
      type: "round",
      icon: `https://unpkg.com/lucide-static@0.321.0/icons/mic.svg`,
    },
    loading: {
      color: `#0096FF`,
      type: "round",
      icon: `https://unpkg.com/lucide-static@0.321.0/icons/loader-2.svg`,
    },
    active: {
      color: `#FF4D4F`,
      type: "round",
      icon: `https://unpkg.com/lucide-static@0.321.0/icons/mic-off.svg`,
    },
  };

  // Prepara o botão personalizado de encerrar chamada
  addCustomHangupButton();

  // Carrega o script Vapi
  const script = document.createElement('script');
  script.id = 'vapi-script';
  script.src = "https://cdn.jsdelivr.net/gh/VapiAI/html-script-tag@latest/dist/assets/index.js";
  script.defer = true;
  script.async = true;
  script.onload = function () {
    // Inicializa o Vapi quando o script for carregado
    vapiInstance = window.vapiSDK.run({
      apiKey: "a9698e0d-3d79-40e3-bbdc-284b90ca5e31", // Chave pública atualizada
      assistant: assistant,
      config: buttonConfig,
    });

    // Configura os event listeners
    setupEventListeners();
    
    // Adiciona o vapiInstance ao window para depuração
    window.vapiInstance = vapiInstance;
    
    // Adiciona os estilos para ocultar o botão e mostrar no hover
    setTimeout(() => {
      addVapiButtonHoverStyles();
    }, 1000); // Aguarda 1 segundo para garantir que o botão foi renderizado
  };
  document.body.appendChild(script);
};

// Configura os event listeners para o Vapi
const setupEventListeners = () => {
  if (!vapiInstance) return;

  vapiInstance.on('speech-start', () => {
    console.log('BIANCA começou a falar');
    const vapiButton = document.querySelector('.vapi-btn');
    if (vapiButton) {
      vapiButton.classList.add('vapi-btn-is-speaking');
    }
  });
  
  vapiInstance.on('speech-end', () => {
    console.log('BIANCA terminou de falar');
    const vapiButton = document.querySelector('.vapi-btn');
    if (vapiButton) {
      vapiButton.classList.remove('vapi-btn-is-speaking');
    }
  });
  
  vapiInstance.on('call-start', () => {
    console.log('Chamada iniciada com BIANCA');
    isCallActive = true;
    // Mostra o botão personalizado de encerrar chamada
    toggleCustomHangupButton(true);
    
    // Garante que o botão Vapi esteja visível e interativo durante a chamada
    const vapiButton = document.querySelector('.vapi-btn');
    if (vapiButton) {
      // Adiciona a classe com um pequeno atraso para garantir que ela seja aplicada após o botão mudar para o estado ativo
      setTimeout(() => {
        vapiButton.classList.add('vapi-btn-is-active');
      }, 300);
    }
  });
  
  vapiInstance.on('call-end', () => {
    console.log('Chamada finalizada com BIANCA');
    isCallActive = false;
    // Esconde o botão personalizado de encerrar chamada
    toggleCustomHangupButton(false);
    
    // Remove a classe que mantém o botão visível após o término da chamada
    const vapiButton = document.querySelector('.vapi-btn');
    if (vapiButton) {
      vapiButton.classList.remove('vapi-btn-is-active');
    }
  });
  
  vapiInstance.on('error', (e) => {
    console.error('Erro na chamada com BIANCA:', e);
    isCallActive = false;
    toggleCustomHangupButton(false);
  });
};

// Função para ativar o assistente programaticamente
export const startVapiCall = () => {
  // O botão do Vapi é gerado automaticamente, então vamos tentar ativar de várias formas
  try {
    // Primeiro, torna o botão visível para garantir que seja clicável
    const vapiButton = document.querySelector('.vapi-btn');
    if (vapiButton) {
      // Força o botão a ficar visível
      vapiButton.style.opacity = '1';
      vapiButton.style.transform = 'scale(1)';
      vapiButton.style.pointerEvents = 'auto';
      
      // Pequeno atraso para garantir que o estilo seja aplicado antes do clique
      setTimeout(() => {
        vapiButton.click();
      }, 100);
      return true;
    } else {
      console.warn('Botão Vapi não encontrado. Tentando método alternativo...');
      // Tenta chamar o método startCall se disponível na nova versão da API
      if (vapiInstance && typeof vapiInstance.startCall === 'function') {
        vapiInstance.startCall();
        return true;
      } else if (window.vapiSDK && typeof window.vapiSDK.openWidget === 'function') {
        window.vapiSDK.openWidget();
        return true;
      }
    }
  } catch (error) {
    console.error('Erro ao tentar iniciar chamada Vapi:', error);
  }
  
  return false;
};

// Função para encerrar a chamada
export const endVapiCall = () => {
  if (!isCallActive) {
    console.log('Não há chamada ativa para encerrar');
    return false;
  }

  try {
    console.log('Tentando encerrar chamada...');
    
    // Método 1: Usando o API stopCall() (se disponível)
    if (vapiInstance && typeof vapiInstance.stopCall === 'function') {
      console.log('Usando método stopCall()');
      vapiInstance.stopCall();
      return true;
    } 
    
    // Método 2: Tentando clicar no botão de desligar
    const vapiButton = document.querySelector('.vapi-btn');
    if (vapiButton && vapiButton.classList.contains('vapi-btn-is-active')) {
      console.log('Clicando no botão Vapi ativo');
      vapiButton.click();
      return true;
    }
    
    // Método 3: Chamar a API mais recente (closeWidget)
    if (window.vapiSDK && typeof window.vapiSDK.closeWidget === 'function') {
      console.log('Usando método closeWidget()');
      window.vapiSDK.closeWidget();
      return true;
    }
    
    console.warn('Não foi possível encerrar a chamada usando os métodos conhecidos');
    return false;
  } catch (error) {
    console.error('Erro ao tentar encerrar chamada Vapi:', error);
    return false;
  }
};
